/**
 * Copyright (c) 2020 Siemens Inc.
 * Unpublished - All rights reserved
 * 
 */
import React, { useState } from "react";

import { decodeLicensingFile } from '../services/licensing-service';
import { getPrettyStr } from '../core/license-formatting';
import ContentCard from './components/content-card';

import { Progress, Toast, ToastHeader, ToastBody } from 'reactstrap';

function DecodeLicensingView() {
    const [decodedLicensingFile, setDecodedLicensingFile] = useState();
    const [loaded, setLoaded] = useState(0);
    const [showError, setShowError] = useState(false);

    /**
     * Executes whenever someone uploads a new file.
     * @param {} event the event containing the file the user wants to upload
     */
    const onFileChangeHandler = async (event) => {
      const file = event.target.files[0];
      await uploadFile(file);
    }

    const onLoadProgress = async(progress) => {
      setLoaded(progress);
    }

    /**
     * Uploads the file to the server, and updates state with the decoded contents
     * @param {*} file 
     */
    const uploadFile = async (file) => {
      const data = new FormData(); 
      data.append('file', file);

      try {
        setShowError(false);
        const resp = await decodeLicensingFile(data, onLoadProgress);
        const formattedOutput = getPrettyStr(resp.data.decodedFile);
        setDecodedLicensingFile(formattedOutput);
      } catch (e) {
        console.error(e);
        setShowError(true);
      }
    }

    const toggleShowError = () => setShowError(!showError);

    function getErrorToast() {
      return (
        <Toast isOpen={showError}>
          <ToastHeader toggle={toggleShowError}>Error</ToastHeader>
          <ToastBody>
            Failed to decode licensing file.
          </ToastBody>
        </Toast>
      );
    }

    return (
        <div>
          <h1 className="text-center">License Decoder</h1>
          <div className="form-group">
            <input id="licenseFileUploadId" type="file" name="licensingFile" onChange={onFileChangeHandler}/>
          </div>
          <div className="form-group">
            <Progress max="100" color="success" value={loaded} >{Math.round(loaded, 2) }%</Progress>
          </div>

          {getErrorToast()}

          {decodedLicensingFile && <ContentCard cardHeader='Decoded File Contents' cardText={decodedLicensingFile} />}
        </div>
    );
}

export default DecodeLicensingView